import { v4 as uuid } from 'uuid';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { StateViewModel } from '../../models/viewModels/StateViewModel';
import { PaymentConstants } from '../PaymentConstants';
import { PAYMENT_ID_PREFIX } from '../../../../../../../../modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderStateService';
import { contentActionsPayment, leavingPaymentActions } from './Actions';
import { conditionOutputPayment } from './Outputs';
export const getPaymentState = (title, textContent) => {
    const id = `${PAYMENT_ID_PREFIX}${uuid()}`;
    const stateVersion = PaymentConstants.CURRENT_PAYMENT_VERSION;
    const defaultOutput = new OutputViewModel({ stateId: id });
    return new StateViewModel({
        id,
        stateVersion,
        root: false,
        $invalid: false,
        $contentActions: contentActionsPayment(textContent),
        $title: title,
        $leavingCustomActions: leavingPaymentActions(),
        $conditionOutputs: conditionOutputPayment.map(o => new OutputViewModel({ ...o, stateId: '' })),
        $defaultOutput: defaultOutput,
        $afterStateChangedActions: [],
        $localCustomActions: [],
        $toolActionsMapping: {
            builder: {
                uuid: uuid(),
            },
        },
    });
};
